//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const slugify = require('speakingurl');

export default {
  props: ['event', 'index', 'images'],
  methods: {
  }
}
